<template>
  <div class="px-8 mt-4">
    <v-dialog
      v-model="dialogAddItem"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      class="ppmpModal"
      scrollable
    >
      <v-card>
        <v-toolbar max-height="65" v-if="ppmpData.PPMPID" dark color="green darken-2">
          <v-toolbar-title
            >{{ ppmpData.PPMPDescription }}
            <span v-if="ppmpData.isDBM">(DBM)</span></v-toolbar-title
          >
          <v-spacer></v-spacer>
          <span
            style="width: 300px"
            v-if="!(ppmpData.Amount > 0) && ppmpData.PPMPStatusID == 11"
          >
            Total <span class="hidden-sm-and-down">Balance </span>: ₱ {{ formatPrice(ppmpData.budgetAmount) }}<br />
            Available <span class="hidden-sm-and-down">Balance </span> : ₱
            {{
              formatPrice(
                parseFloat(ppmpData.budgetAmount) - parseFloat(ppmpUsedAmount)
              )
            }}
          </span>
          <span style="width: 300px" v-else>
            Total <span class="hidden-sm-and-down">Balance </span>: ₱ {{ formatPrice(ppmpData.Amount) }} <br />
            Available <span class="hidden-sm-and-down">Balance </span>: ₱
            {{
              formatPrice(
                parseFloat(ppmpData.Amount) - parseFloat(ppmpUsedAmount)
              )
            }}
          </span>
          <v-btn icon dark @click="clickCloseMainDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <!-----Stepper----->
        <div>

<!-- <v-stepper alt-labels>
            <v-stepper-header>
              <v-stepper-step
                color="green"
                step="1"
                class="pa-3 pl-md-16"
                :complete="prData.FinanceStatusID == 7"
              >
              <span class="text-no-wrap">Funds Availability</span>
              <small class="text-no-wrap font-size-12 font-weight-bold">{{formatDateTime(prData.FinaceApprovedDate)}}</small>
              </v-stepper-step>

              <v-divider class="my-6"></v-divider>

              <v-stepper-step
                color="green"
                :complete="prData.PresidentStatusID == 7"
                step="2"
                class="pa-3 pr-md-16"
              >
                <span class="text-no-wrap">College President Approval</span>
                <small class="text-no-wrap font-size-12 font-weight-bold">{{formatDateTime(prData.PresidentApprovedDate)}}</small>
              </v-stepper-step>
            </v-stepper-header>
          </v-stepper> -->

          <v-stepper alt-labels>
            <v-stepper-header>
              <v-stepper-step
                color="green"
                step="1"
                :complete="ppmpData.RecommendingApprovalStatusID == 7"
                class="pa-3"
              >
                <span class="text-no-wrap">Recommending Approval</span>
                <small class="text-no-wrap font-size-12 font-weight-bold">{{formatDateTime(ppmpData.RecommendingApprovalDate)}}</small>
              </v-stepper-step>

              <v-divider class="my-6"></v-divider>

              <v-stepper-step
                color="green"
                step="2"
                :complete="ppmpData.BudgetStatusID == 7"
                class="pa-3"
              >
              <span class="text-no-wrap">Budget Officer Approval</span>
              <small class="text-no-wrap font-size-12 font-weight-bold">{{formatDateTime(ppmpData.BudgetApprovedDate)}}</small>
              </v-stepper-step>

              <v-divider class="my-6"></v-divider>

              <v-stepper-step
                color="green"
                step="3"
                :complete="ppmpData.FinanceStatusID == 7"
                class="pa-3"
              >
                <span class="text-no-wrap">Funds Availability</span>
                <small class="text-no-wrap font-size-12 font-weight-bold">{{formatDateTime(ppmpData.FinanceApprovedDate)}}</small>
              </v-stepper-step>

              <v-divider class="my-6"></v-divider>

              <v-stepper-step
                color="green"
                :complete="ppmpData.PresidentStatusID == 7"
                step="4"
                class="pa-3"
              >
                <span class="text-no-wrap">College President Approval</span>
                <small class="text-no-wrap font-size-12 font-weight-bold">{{formatDateTime(ppmpData.PresidentApprovedDate)}}</small>
              </v-stepper-step>
            </v-stepper-header>
          </v-stepper>
        </div>

        <v-alert
          v-if="ppmpData.isPending && ppmpData.PresidentStatusID != 7"
          border="left"
          type="error"
          class="white--text amber accent-4"
          prominent
          dense
        >
          <div v-if="ppmpData.RecommendingApprovalRemarks"> <strong>Recommending Approval: </strong>{{ ppmpData.RecommendingApprovalRemarks }}</div>
          <div v-if="ppmpData.BudgetRemarks"> <strong>Budget Officer: </strong>{{ ppmpData.BudgetRemarks }}</div>
          <div v-if="ppmpData.FinanceRemarks"> <strong>Finance: </strong>{{ ppmpData.FinanceRemarks }}</div>
          <div v-if="ppmpData.PresidentRemarks"> <strong>College President: </strong>{{ ppmpData.PresidentRemarks }}</div>
        </v-alert>

        <!-----Header----->
        <v-card-text style="max-height: 2000px">
        <div>
          <v-row class="mt-4">
            <v-col cols="12" class="d-flex justify-center">
              <v-subheader class="font-weight-bold text-h6 text-center"
                >Project Procurement Management Plan (PPMP)</v-subheader
              >
            </v-col>
            <v-col cols="12" class="d-flex justify-center mt-n8">
              <v-subheader
                >{{ ppmpData.DateStart }} - {{ ppmpData.DateEnd }}</v-subheader
              >
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-5">
            <v-col cols="12" sm="6" md="2">
              <v-subheader class="font-weight-bold">Delivery Unit:</v-subheader>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-subheader>{{
                ppmpDetails.DeliveryUnitDescription
              }}</v-subheader>
            </v-col>

            <v-col cols="12" sm="6" md="2">
              <v-subheader class="font-weight-bold"
                >Office/ Committee:</v-subheader
              >
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-subheader>{{ ppmpDetails.OfficeDescription }}</v-subheader>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col cols="12" sm="6" md="2">
              <v-subheader class="font-weight-bold"
                >Program/ Activity/ Project (PAP) Title:</v-subheader
              >
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-subheader>{{ ppmpDetails.PurposeDescription }}</v-subheader>
            </v-col>

            <v-col cols="12" sm="6" md="2">
              <v-subheader class="font-weight-bold">Fund Source:</v-subheader>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-subheader>{{ ppmpDetails.FundCode }}</v-subheader>
            </v-col>
          </v-row>

          <v-row no-gutters class="mb-5">
            <v-col cols="12" sm="6" md="2">
              <v-subheader class="font-weight-bold"
                >Specific Fund Source/ Fee:</v-subheader
              >
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-subheader>{{
                ppmpDetails.SpecificFundSourceDescription
              }}</v-subheader>
            </v-col>

            <v-col cols="12" sm="6" md="2">
              <v-subheader class="font-weight-bold">Budget Code:</v-subheader>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-subheader>{{ ppmpDetails.BudgetCode }}</v-subheader>
            </v-col>
          </v-row>
        </div>

        <v-row>
          <v-col lg="12" class="py-4">
            <v-card class="">
              <v-data-table
                :loading="loading"
                :headers="headers"
                :items="itemList"
                :options.sync="options"
                :server-items-length="totalCount"
                :footer-props="footerProps"
                class="elevation-1"
              >
                <template v-slot:top>
                  <v-toolbar flat>
                    <span class="green--text text--darken-2"
                      >PPMP Item List</span
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                      outlined
                      color="red darken-2"
                      dark
                      @click="print(ppmpData)"
                      class="mr-2"
                    >
                      <v-icon>print</v-icon>
                      Print
                    </v-btn>
                    <v-btn
                      outlined
                      color="red darken-2"
                      dark
                      v-if="ppmpData.parentPPMPID > 0 && ppmpData.PPMPTypeID == 2"
                      @click="printWithOldPPMP(ppmpData)"
                      class="mr-2"
                    >
                      <v-icon>print</v-icon>
                      Print  W/ Old PPMP
                    </v-btn>
                    <v-btn
                      outlined
                      color="red darken-2"
                      dark
                      v-if="ppmpData.parentPPMPID > 0 && ppmpData.PPMPTypeID == 3"
                      @click="printWithOldLIB(ppmpData)"
                      class="mr-2"
                    >
                      <v-icon>print</v-icon>
                      Print  W/ Old LIB
                    </v-btn>
                    <v-btn
                      v-if="($store.state.user.roleID == 9 && ppmpData.FinanceStatusID != 7 && ppmpData.PresidentStatusID == 0) || ($store.state.user.roleID == 8 && ppmpData.PresidentStatusID != 7) || ($store.state.user.IsRA == 1 && ppmpData.RecommendingApprovalStatusID != 7 && ppmpData.BudgetStatusID == 0) || ($store.state.user.roleID == 7 && ppmpData.BudgetStatusID != 7 && ppmpData.FinanceStatusID == 0)"
                      color="green darken-2"
                      dark
                      outlined
                      elevation="2"
                      class="mr-2"
                      @click="approveItem(ppmpData)"
                    >
                      Approve
                    </v-btn>
                    <v-btn
                      v-if="($store.state.user.roleID == 9 && ppmpData.FinanceStatusID != 6 && ppmpData.PresidentStatusID == 0) || ($store.state.user.roleID == 8 && ppmpData.PresidentStatusID != 6) || ($store.state.user.IsRA == 1 && ppmpData.RecommendingApprovalStatusID != 6 && ppmpData.BudgetStatusID == 0) || ($store.state.user.roleID == 7 && ppmpData.BudgetStatusID != 6 && ppmpData.FinanceStatusID == 0)"
                      color="red darken-2"
                      dark
                      outlined
                      elevation="2"
                      class="mr-2"
                      @click="pendingItem(ppmpData)"
                    >
                      Pending
                    </v-btn>
                  </v-toolbar>
                </template>
                <template v-slot:[`item.Qty`]="{ item }">
                  <span class="text-no-wrap">{{ formatQty(item.Qty) }}</span>
                </template>
                <template v-slot:[`item.UnitCost`]="{ item }">
                  <span class="text-no-wrap">₱ {{ formatPrice(item.UnitCost || 0) }}</span>
                </template>
                <template v-slot:[`item.Amount`]="{ item }">
                  <span class="text-no-wrap">₱ {{formatPrice(parseFloat(item.UnitCost) * parseFloat(item.Qty))}}</span>
                </template>
                <template v-slot:[`item.Requested`]="{ item }">
                  <v-icon
                  small
                  v-if="item.PRID != 0"
                  class="mx-3"
                  color="green"
                  >mdi-check</v-icon>
                </template>
                <template v-slot:[`item.Revised`]="{ item }">
                  <v-icon
                  small
                  v-if="item.isRevised == 1"
                  class="mx-3"
                  color="green"
                  >mdi-check</v-icon>
                </template>
                <template v-slot:[`item.Utilized`]="{ item }">
                  <span class="text-no-wrap">₱ {{formatPrice(item.Utilized)}}</span>
                </template>
                <template v-slot:[`item.Obligation`]="{ item }">
                  <span class="text-no-wrap">₱ {{ formatPrice(getObligationAmount(item)) }}</span>
                </template>
                <template v-slot:[`item.Balance`]="{ item }">
                  <span class="text-no-wrap">₱ {{formatPrice(((parseFloat(item.UnitCost) * parseFloat(item.Qty)) - parseFloat(getObligationAmount(item))) - parseFloat(item.Utilized))}}</span>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                        <v-btn
                          x-small
                          color="primary"
                          class="mr-2 white--text"
                          @click="mop(item)"
                          v-if="$store.state.user.roleID == 7"
                        > 
                          Edit MOP
                        </v-btn>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="filelist_uploaded.length > 0">
          <v-col cols="12" class="pb-10">
            <v-card class="">
            <v-data-table
              :headers="headers3"
              :items="filelist_uploaded"
              :options.sync="options2"
              :loading="loading2"
              :footer-props="footerProps"
              class="elevation-1 pt-2"
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <h3>Attachments</h3>
                  <v-spacer></v-spacer>
                  <!-- <v-text-field
                    style="max-width: 300px"
                    v-model="searchText"
                    append-icon="mdi-magnify"
                    placeholder="Search attachment"
                    color="green darken-2"
                    class="mr-2 mb-2"
                    dense
                    hide-details
                  ></v-text-field> -->
                </v-toolbar>
              </template>
              <template v-slot:[`item.filename`]="{ item }">
                <span class="text-no-wrap">{{item.name}}</span>
              </template>
              <template v-slot:[`item.size`]="{ item }">
                <span v-if="item.size < 1024">
                  {{formatQty(parseFloat(item.size).toFixed(2))}} byte(s)
                </span>
                <span v-else-if="item.size < 1048576">
                  {{(formatQty(parseFloat(item.size) / 1024).toFixed(2))}} KB(s)
                </span>
                <span v-else>
                  {{(formatQty(parseFloat(item.size) / 1048576).toFixed(2))}} MB(s)
                </span>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-btn
                  color="blue darken-2"
                  dark
                  outlined
                  elevation="2"
                  x-small
                  @click="preview_old(item)"
                >
                  View
                </v-btn>
              </template>
            </v-data-table>
            </v-card>
          </v-col>
        </v-row>
        </v-card-text>
      </v-card>
      <v-btn fab dark large color="header" @click="viewRemarks()" fixed left bottom>
        <v-badge
          color="red darken-2"
          :content="unseenMsgs"
          :value="unseenMsgs"
        >
          <v-icon dark>mdi-email</v-icon>
        </v-badge>
    </v-btn>
    </v-dialog>
    <v-dialog v-model="addToPPMP" persistent max-width="700px">
      <v-card>
        <v-card-title>
          <span class="subtitle-1 font-weight-bold" v-if="editItemId"
            >Update Item</span
          >
          <span class="subtitle-1 font-weight-bold" v-else>Add Item</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form @submit.prevent ref="Formref">
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <span v-if="editItemId">
                    <v-list-item-content>
                      <v-list-item-title
                        ><b>{{ formData.ItemName }}</b></v-list-item-title
                      >
                      <v-list-item-subtitle>{{
                        formData.itemDescription
                      }}</v-list-item-subtitle>
                      <span
                        >₱ {{ formatPrice(formData.UnitCost) }} /
                        {{ formData.UnitMeasureDescription }}</span
                      >
                    </v-list-item-content>
                    <v-divider></v-divider>
                    <br />
                  </span>
                  <v-autocomplete
                    v-else
                    v-model="formData.ItemID"
                    color="green"
                    item-text="ItemName"
                    item-value="ItemID"
                    :rules="[formRules.required]"
                    :items="items"
                    :loading="itemsisLoading"
                    :search-input.sync="search"
                    dense
                    label="Item"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-title>
                          Search for an Item
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                    <template v-slot:selection="data">
                      <template>
                        <v-list-item-content>
                          <v-list-item-title>{{
                            data.item.ItemName
                          }}</v-list-item-title>
                          <v-list-item-subtitle>{{
                            data.item.ItemDescription
                          }}</v-list-item-subtitle>
                          <span
                            >₱ {{ formatPrice(data.item.UnitCost) }} /
                            {{ data.item.UnitMeasureDescription }}</span
                          >
                        </v-list-item-content>
                      </template>
                    </template>
                    <template v-slot:item="data">
                      <template>
                        <v-list-item-content>
                          <v-list-item-title>{{
                            data.item.ItemName
                          }}</v-list-item-title>
                          <v-list-item-subtitle>{{
                            data.item.ItemDescription
                          }}</v-list-item-subtitle>
                          <span
                            >₱ {{ formatPrice(data.item.UnitCost) }} /
                            {{ data.item.UnitMeasureDescription }}</span
                          >
                        </v-list-item-content>
                      </template>
                    </template>
                  </v-autocomplete>
                  <v-text-field
                    outlined
                    dense
                    color="green"
                    style="width: 190px"
                    label="Quantity"
                    :rules="[checkQtyandBalance(), formRules.noNegativeNumberAllowed, formRules.numberRequired]"
                    v-model="formData.Qty"
                    class="pa-0 mt-4"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="cancel()"> Cancel </v-btn>
          <v-btn
            v-if="!editItemId"
            :loading="loadingBtn"
            color="green darken-2"
            text
            @click="addItemtoPPMP()"
          >
            Add Item
          </v-btn>
          <v-btn
            v-else
            color="red darken-1"
            text
            @click="update()"
            :loading="loadingBtn"
          >
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      
        <v-dialog v-model="dialogPending" persistent max-width="450px">
      <v-card>
        <v-card-title>
          <span class="headline">Pending PPMP</span>
          <v-spacer></v-spacer>
          <v-btn icon dark color="secondary2" @click="dialogPending = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-form @submit.prevent ref="formRef">
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-textarea
                    color="green"
                    dense
                    v-model="remarks"
                    :rules="[formRules.required]"
                    label="Remarks"
                    counter
                    maxlength="500"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogPending = false">dialogApprove
            Cancel
          </v-btn>
          <v-btn color="green darken-1" text @click="confirmReturn()">
            Return PPMP
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogApprove" max-width="500px">
      <v-card>
        <v-card-title class="text-h6"
          >Are you sure you want to approve this PPMP?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-2" text @click="dialogApprove = false"
            >Cancel</v-btn
          >
          <v-btn color="green darken-2" @click="confirmApprove()" text
            >Yes</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogMOP" persistent max-width="450px">
      <v-card>
        <v-card-title>
          <span class="">Edit Procurement Details</span>
          <v-spacer></v-spacer>
          <v-btn icon dark color="secondary2" @click="dialogMOP = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-form @submit.prevent ref="formRef2">
          <v-card-text>
              <v-row no-gutters class="mb-1">
                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                  color="green"
                  v-model="MOPID"
                  item-text="mopDescription"
                  item-value="mopID"
                  :items="MOPList"
                  dense
                  :rules="[formRules.required]"
                  outlined
                  label="Mode of Procurement"
                >
                </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    color="green"
                    label="Pre-Procurement Conference"
                    v-model="PreProcurement"
                    :rules="[formRules.required]"
                    :items="['Yes', 'No']"
                    outlined
                    dense
                  ></v-autocomplete>
                </v-col>
              </v-row>
          </v-card-text>
        </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" outlined @click="dialogMOP = false">
            Cancel
          </v-btn>
          <v-btn color="primary darken-1" class="white--text" @click="confirmMOP()">
            <v-icon class="mr-1">mdi-check-circle</v-icon>
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
<PSURemarks :data="ppmpRemarksData" />
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>
    
    <script>
    import PSURemarks from './PSURemarks.vue'
export default {
  components: {
      PSURemarks
    },
  props: {
    ppmpData: {},
    forApproval: null
  },
  data: () => ({
    ppmpDetails: [],
    itemsisLoading: false,
    items: [],
    search: null,
    ppmpUsedAmount: null,
    headers: [
      {
        text: "Item Name",
        align: "start",
        sortable: false,
        value: "ItemName",
      },
      { text: "Description", value: "itemDescription", sortable: false },
      { text: "Mode", value: "mopDescription", sortable: false },
      { text: "Quantity", value: "Qty", sortable: false, align: "center" },
      { text: "Unit Meas.", value: "UnitMeasureDescription", sortable: false, align: "center" },
      { text: "Unit Cost", value: "UnitCost", sortable: false, align: "end" },
      { text: "Amount", value: "Amount", sortable: false, align: "end" },
      { text: "Requested", value: "Requested", sortable: false, align: "center" },
      { text: "Revised", value: "Revised", sortable: false, align: "center" },
      { text: "Utilized", value: "Utilized", sortable: false, align: "end" },
      { text: "Obligation", value: "Obligation", sortable: false, align: "end" },
      { text: "Balance", value: "Balance", sortable: false, align: "end" },
      { text: "Action", value: "actions", sortable: false },
    ],
    obligation_headers: [
       {
        text: "Description",
        align: "start",
        sortable: false,
        value: "ObligationDescription",
      },
      { text: "Amount", value: "Amount", sortable: false },
      { text: "Date Obligated", value: "DateCreated", sortable: false },
      { text: "Action", value: "actions", sortable: false, align: 'center' },
    ],
    months: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Added!",
      message: "",
      top: 10,
    },
    addToPPMP: false,
    loading: false,
    ppmp: [],
    dialogAddItem: false,
    footerProps: { "items-per-page-options": [5, 10, 20, 50, 100, 500] },
    totalCount: 0,
    options: {},
    isLoading: false,
    itemList: [],
    formData: {
      ppmpID: null,
      ItemID: null,
      Qty: null,
      ItemName: null,
      UnitCost: null,
      UnitMeasureDescription: null,
      itemDescription: null,
      DateSchedules: null,
    },
    loadingBtn: false,
    editItemId: null,
    editItemQty: null,
    selectSchedDialog: false,
    dialogConfirmUnpublish: false,
    toUnpublishPPMPID: null,
    dialogConfirmObligation: false,
    ppmpItemSelected: null,
    obligationSelected: null,
    itemNameSelected: '',
    dialogObligations: false,
    obligationList: [],
    obligation: [],
    obligations: [],
    dialogAddObligation: false,
    AddPPMPItemID: null,
    obligationListTotal: 0,
    deleteObligationList: [],
    selectedAmount: 0,
    itemToDelete: [],
    dialogDelete: false,
    ppmpRemarksData: [],
    unseenMsgs: 0,
    dialogPending: false,
    dialogApprove: false,
    remarks: '',
    dialogMOP: false,
    MOPData: {},
    MOPList: [],
    MOPID: null,
    PreProcurement: "No",
    filelist_uploaded: [],
    headers3: [
      {
        text: "FileName",
        value: "filename",
        sortable: false,
        class: "green darken-2 white--text text-caption font-weight-bold",
      },
      {
        text: "Size",
        value: "size",
        align: "center",
        sortable: false,
        width: 150,
        class: "green darken-2 white--text text-caption font-weight-bold",
      },
      {
        text: "Actions",
        value: "actions",
        align: "center",
        sortable: false,
        width: 150,
        class: "green darken-2 white--text text-caption font-weight-bold",
      },
    ],
    loading2: false,
    options2: {},
  }),
  watch: {
    search(val) {
      this.itemsisLoading = true;
      setTimeout(() => {
        if (val == this.search) {
          this.SearchItem();
        }
      }, 2000);
    },
    options: {
      handler() {
        if (this.totalCount > 0) {
          this.getItems();
        }
      },
      deep: true,
    },
    ppmpData: {
      handler(data) {
        if (data.PPMPID) {
          this.deleteObligationList = [];
          this.dialogAddItem = true;
          this.getItems();
          this.getUnseenMsgs();
          this.getAttachmentsByPPMP();
        }
      },
      deep: true,
    },
    forApproval: {
      handler() {
      },
      deep: true,
    },
    obligationList: {
      handler(data) {
        let total = 0;
        data.forEach(item => {
          total += parseFloat(item.Amount);
        });
          this.obligationListTotal = total;
      },
      deep: true,
    },
  },
  mounted() {
         this.getMOPList();

        this.eventHub.$on('closePSURemarks', ()=>{
          this.ppmpRemarksData = [];
         this.getUnseenMsgs();
        });
  },
  beforeDestroy() {
         this.eventHub.$off('closePSURemarks');
    },
  methods: {
    viewRemarks(){
      this.ppmpRemarksData = {
        id: this.ppmpData.PPMPID,
        DocType: 1,
        RemarksID: this.ppmpData.RemarksID
      };
      if(this.unseenMsgs > 0){
        let data = new FormData();
        data.append("RemarksID", this.ppmpData.RemarksID);
        this.axiosCall("/remarks/seen", "POST", data).then((res) => {
          console.log(res)
          this.unseenMsgs = 0
        });
      }
    },
    getUnseenMsgs(){
      this.unseenMsgs = 0;
        let data = new FormData();
        data.append("RemarksID", this.ppmpData.RemarksID);
        this.axiosCall("/getUnseenMsgs", "POST", data).then((res) => {
        this.unseenMsgs = res.data.data
      });
    },
    swithcChange() {
      console.log(this.ppmpData.isOpen);

      let data = new FormData();
      data.append("PPMPID", this.ppmpData.PPMPID);
      data.append("swithcVal", this.ppmpData.isOpen);
      this.axiosCall("/signatories/PPMP/open/close", "POST", data).then(
        (res) => {
          console.log(res);
        }
      );
    },
    whoCanUse() {
      return (
        (this.$store.state.user.roleID != 7 &&
          this.$store.state.user.roleID != 8 &&
          this.$store.state.user.roleID != 9 &&
          this.$store.state.user.roleID != 10) ||
        !this.$route.name
      );
    },
    ableToUnpublish() {
      let res = false;
        this.itemList.forEach(item => {
          if (item.PRID == 0 && item.PRstatus == 0) {
          res = true;
        }
        });
      return res;
    },
    unpublish(PPMPID) {
      this.dialogConfirmUnpublish = true;
      this.toUnpublishPPMPID = PPMPID;
    },
    confirmUnpublish(){
      let data = new FormData();
      data.append("PPMPID", this.toUnpublishPPMPID);
      this.axiosCall("/ppmp/unpublish", "POST", data).then((res) => {
        if(res.data.status) {
            this.toUnpublishPPMPID = null;
            this.dialogConfirmUnpublish = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = 'success';
            this.fadeAwayMessage.message = 'PPMP successfully unpublished!';
            this.fadeAwayMessage.header = 'System Message';
            this.dialogAddItem = false;
            }else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = 'error';
            this.fadeAwayMessage.message = res.data.message;
            this.fadeAwayMessage.header = 'System Message';
            }
      });
    },
    publish(item) {
      let data = new FormData();
      data.append("PPMPID", item.PPMPID);
      data.append("Amount", this.ppmpUsedAmount);
      data.append("isDBM", item.isDBM);
      data.append("BudgetID", item.BudgetID);
      this.axiosCall("/ppmp/publish", "POST", data).then((res) => {
        this.clickCloseMainDialog();
        if (res.data.status) {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.message = "Published Successfully!";
          this.fadeAwayMessage.header = "System Message";
        } else {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.message = "Something went wrong try again!";
          this.fadeAwayMessage.header = "System Message";
        }
      });
    },
    SaveDate() {
      if(this.$refs.Formref2.validate()){
        if (this.formData.DateSchedules) {
        this.selectSchedDialog = false;
        this.addToPPMP = true;
      }
      }
    },
    addItemBtn() {
      if (this.ppmpData.isDBM) {
        this.formData.DateSchedules = "January";
        this.addToPPMP = true;
      } else {
        this.selectSchedDialog = true;
      }
    },
    editItem(data) {
      if (
        this.ppmpData.PPMPStatusID == 11 &&
        this.ppmpData.isOpen == 1 &&
        this.whoCanUse()
      ) {
        this.editItemQty = data.Qty;
        this.editItemId = data.ppmpItemID;
        this.formData.Qty = data.Qty;
        this.formData.ItemName = data.ItemName;
        this.formData.UnitCost = data.UnitCost;
        this.formData.UnitMeasureDescription = data.UnitMeasureDescription;
        this.formData.itemDescription = data.itemDescription;
        this.formData.ItemID = data.ItemID;
        this.addToPPMP = true;
      }
    },
    deleteItem(item) {
      this.itemToDelete = item;
      this.dialogDelete = true;
    },
    confirmDeleteItem(){
      if (
        this.ppmpData.PPMPStatusID == 11 &&
        this.ppmpData.isOpen == 1 &&
        this.whoCanUse()
      ) {
        let data = new FormData();
        data.append("deleteID", this.itemToDelete.ppmpItemID);
        this.axiosCall("/delete/ppmp/item", "POST", data).then((res) => {
          console.log(res);
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.message = "Item Successfully Deleted from PPMP!";
          this.fadeAwayMessage.header = "System Message";
          this.itemToDelete = [];
          this.dialogDelete = false;
          this.getItems();
        });
      }
    },
    checkQtyandBalance() {
      let balance =
        parseFloat(this.ppmpData.Amount) - parseFloat(this.ppmpUsedAmount);
      if (this.ppmpData.isDBM && parseFloat(this.ppmpData.Amount) < 1) {
        balance =
          parseFloat(this.ppmpData.budgetAmount) -
          parseFloat(this.ppmpUsedAmount);
      }
      let itemID = this.formData.ItemID;
      let qty = this.formData.Qty;
      if (!itemID) {
        return true;
      }
      let itemAmount = 0;
      if (this.editItemId) {
        itemAmount =
          parseFloat(this.formData.UnitCost) * parseFloat(this.formData.Qty) -
          parseFloat(this.formData.UnitCost) * parseFloat(this.editItemQty);
      } else {
        this.items.forEach((element) => {
          if (element.ItemID == itemID) {
            itemAmount = element.UnitCost * qty;
          }
        });
      }
      if (balance && itemAmount) {
        balance = balance.toFixed(2);
        itemAmount = itemAmount.toFixed(2);
      }
      return (
        parseFloat(balance) >= parseFloat(itemAmount) || "Insufficient Balance"
      );
    },
    SearchItem() {
      let data = new FormData();
      data.append("search", this.search);
      data.append("isDBM", this.ppmpData.isDBM);
      this.axiosCall("/search/item", "POST", data).then((res) => {
        this.items = res.data.data.result;
        this.itemsisLoading = false;
        this.$forceUpdate();
      });
    },
    clickCloseMainDialog() {
      this.formData.DateSchedules = null;
      this.totalCount = 0;
      this.items = [];
      this.dialogAddItem = false;
      this.eventHub.$emit("closePPMPModal", false);
    },
    print(data) {
      if(data.PPMPTypeID == 3){
        window.open(
          this.apiUrl + "/ppmp/report/lib/" + data.PPMPID + "/" + data.BudgetID
        );
      }
      else{
        window.open(
          this.apiUrl + "/ppmp/report/" + data.PPMPID + "/" + data.BudgetID
        );
      }
    },
    printWithOldPPMP(data) {
      window.open(
        this.apiUrl + "/ppmp/report/" + data.PPMPID + "/" + data.BudgetID + "/revised"
      );
    },
    printWithOldLIB(data) {
      window.open(
        this.apiUrl + "/ppmp/report/lib/" + data.PPMPID + "/" + data.BudgetID + "/revised"
      );
    },
    cancel() {
      this.editItemQty = null;
      (this.editItemId = null), this.$refs.Formref.reset();
      this.addToPPMP = false;
    },
    update() {
      if (this.$refs.Formref.validate()) {
        this.loadingBtn = true;
        let data = new FormData();
        data.append("Qty", this.formData.Qty);
        data.append("ppmpItemID", this.editItemId);
        data.append("itemID", this.formData.ItemID);
        data.append("UnitCost", this.formData.UnitCost);
        this.axiosCall("/ppmp/edit/item", "POST", data).then((res) => {
          this.loadingBtn = false;
          if (res.data.status) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = "Item Successfully Updated!";
            this.fadeAwayMessage.header = "System Message";
            this.cancel();
            this.getItems();
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = "Something went wrong try again!";
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },
    addItemtoPPMP() {
      if (this.$refs.Formref.validate()) {
        let UnitCost = 0;
        this.items.forEach((element) => {
          if (element.ItemID == this.formData.ItemID) {
            UnitCost = element.UnitCost;
          }
        });
        this.loadingBtn = true;
        let data = new FormData();
        data.append("Qty", this.formData.Qty);
        data.append("ppmpID", this.ppmpData.PPMPID);
        data.append("itemID", this.formData.ItemID);
        data.append("UnitCost", UnitCost);
        data.append("DateSchedules", this.formData.DateSchedules);
        this.axiosCall("/ppmp/add/item", "POST", data).then((res) => {
          this.loadingBtn = false;
          if (res.data.status) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = "Item Successfully Added!";
            this.fadeAwayMessage.header = "System Message";
            this.cancel();
            this.getItems();
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.message;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },
    addItems(data) {
      this.formData.ppmpID = data.PPMPID;
      this.dialogAddItem = true;
    },
    addItemQty(data) {
      this.formData.ItemID = data.ItemID;
      this.formData.UnitMeasure = data.UnitMeasureDescription;
      this.addToPPMP = true;
      console.log(this.formData.UnitMeasure);
    },
    initialize() {
      this.loading = true;
      this.axiosCall("/get/PPMP", "GET").then((res) => {
        this.loading = false;
        this.ppmp = res.data.data.result;
      });
    },
    getItems() {
      let data = new FormData();
      if (this.options.page) {
        data.append("page", this.options.page);
        data.append("itemsPerPage", this.options.itemsPerPage);
      } else {
        data.append("page", 1);
        data.append("itemsPerPage", 10);
      }
      data.append("BudgetID", this.ppmpData.BudgetID);
      data.append("PPMPID", this.ppmpData.PPMPID);
      data.append("isDBM", this.ppmpData.isDBM);
      this.axiosCall("/getPPMPItem", "POST", data).then((res) => {
        this.loading = false;
        this.itemList = res.data.data.result;
        this.totalCount = res.data.data.total;
        if (this.totalCount <= 10) {
          this.options.page = 1;
        }
        this.ppmpUsedAmount = parseFloat((res.data.data.useAmount).toFixed(2));
        this.ppmpDetails = res.data.data.details;
        this.obligations = res.data.data.obligations;
      });
    },
    obligate(data){
      this.obligationList = [];
      this.obligations.forEach(item => {
        if(item.PPMPItemID == data.ppmpItemID){
          this.obligationList.push(item);
        }
      });
      this.AddPPMPItemID = data.ppmpItemID;
      this.selectedAmount = parseFloat(data.Qty) * parseFloat(data.UnitCost);
      this.dialogObligations = true;
    },
    getObligationAmount(data){
      let total = 0;
        this.obligations.forEach(item => {
          if(item.PPMPItemID == data.ppmpItemID){
            total += parseFloat(item.Amount);
          }
        });
        return total;
    },
    addObligation(){
      if (this.$refs.FormrefObligation.validate()) {
        let today = new Date();
        this.obligationList.push(
          {
            'PPMPItemID': this.AddPPMPItemID,
            'ObligationDescription': this.obligation.ObligationDescription,
            'Amount': this.obligation.Amount,
            'DateCreated': this.formatDate(today)
          });
        this.dialogAddObligation = false;
        this.$refs.FormrefObligation.reset();
      }
    },
    saveObligations(){
      if(this.obligationList.reduce((n, {Amount}) => n + Amount, 0) <= this.selectedAmount){
      let data = new FormData();
      data.append("obligations",  JSON.stringify(this.obligationList));
      data.append("deleteObligations",  JSON.stringify(this.deleteObligationList));
      this.axiosCall("/obligation/save", "POST", data).then((res) => {
        if (res.data.status) {
          this.dialogAddObligation = false;
          this.dialogObligations = false;
          this.getItems();
          this.deleteObligationList = [];
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.message = "Obligations Successfully Saved!";
          this.fadeAwayMessage.header = "System Message";
          this.$refs.FormrefObligation.reset();
        } else {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.message = res.data.message;
          this.fadeAwayMessage.header = "System Message";
        }
      });
      }
      else{
        this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.message = "Unable to save the obligation. Please check the details.";
          this.fadeAwayMessage.header = "System Message";
      }
    },
    removeObligation(item){
      let index = this.obligationList.indexOf(item);
      if (index > -1) {
        if(typeof item.ObligationID !== 'undefined'){
        this.deleteObligationList.push(item);
        }
        this.obligationList.splice(index, 1);
      }
    },
    pendingItem() {
      let role = this.$store.state.user;
      if (role.roleID == 7) {
        this.remarks = this.ppmpData.BudgetRemarks;
      }
      if (role.roleID == 8) {
        this.remarks = this.ppmpData.PresidentRemarks;
      }
      if (role.roleID == 9) {
        this.remarks = this.ppmpData.FinanceRemarks;
      }
      if (role.roleID == 10) {
        this.remarks = this.ppmpData.RecommendingApprovalRemarks;
      }
      this.dialogPending = true;
    },
    approveItem() {
      this.dialogApprove = true;
    },
    confirmReturn() {
      if (this.$refs.formRef.validate()) {
        let data = new FormData();
        data.append("Remarks", this.remarks);
        data.append("PPMPID", this.ppmpData.PPMPID);
        if (this.ppmpData.RA) {
          data.append("RA", true);
        }
        this.axiosCall("/signatories/PPMP/pending", "POST", data).then(
          (res) => {
            console.log(res);
            this.dialogPending = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = "PPMP Successfully pending!";
            this.fadeAwayMessage.header = "System Message";
            this.clickCloseMainDialog();
          }
        );
      }
    },
    confirmApprove() {
      let data = new FormData();
      data.append("PPMPID", this.ppmpData.PPMPID);
      if (this.ppmpData.RA) {
        data.append("RA", true);
      }
      this.axiosCall("/signatories/PPMP/approve", "POST", data).then((res) => {
        console.log(res);
        this.dialogApprove = false;
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "success";
        this.fadeAwayMessage.message = "PPMP Successfully Approved!";
        this.fadeAwayMessage.header = "System Message";
        this.clickCloseMainDialog();
      });
    },
    mop(data) {
      this.dialogMOP = true;
      this.MOPID = data.MOPID
      this.PreProcurement = data.PreProcurement && data.PreProcurement == 1 ? 'Yes' : 'No'
      this.MOPData = data;
    },
    getMOPList(){
      let data = new FormData();
        this.axiosCall("/get/all/mop", "POST", data).then((res) => {
        this.MOPList = res.data.data
      });
    },
    confirmMOP() {
      let data = new FormData();
      data.append("ppmpItemID", this.MOPData.ppmpItemID);
      data.append("MOPID", this.MOPID);
      data.append("PreProcurement", this.PreProcurement);
      this.axiosCall("/signatories/PPMP/mop", "POST", data).then((res) => {
        if(res){
          this.dialogMOP = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.message = "MOP was successfully updated!";
          this.fadeAwayMessage.header = "System Message";
          this.getItems();
        }
        else{
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.message = "Something went wrong!";
          this.fadeAwayMessage.header = "System Message";
        }
      });
    },
    getAttachmentsByPPMP(){
      let data = new FormData();
      data.append("BudgetID", this.ppmpData.BudgetID);
      data.append("PPMPID", this.ppmpData.PPMPID);
      data.append("Revised", this.ppmpData.parentPPMPID > 0 ? 1 : 0);
      this.axiosCall(
              '/attachment/getByPPMP',
              'POST',
              data
          )
          .then((res) => {
              if (res.data.status){
                this.filelist_uploaded = res.data.data
              }
              else{
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = 'error';
              this.fadeAwayMessage.message = res.data.message;
              this.fadeAwayMessage.header = 'System Message';
              }
          })
    },
    preview_old(file) {
        // console.log(file)
        window.open(this.apiUrl + '/attachment/' + file.id, '_blank');
      },
  },
};
</script>
        
    <style scoped>
.v-dialog--fullscreen,
.ppmpModal {
  overflow-x: hidden !important;
}
</style>